<template>
    <div class="avatar-stack">
        <ul class="list">
            <li
                v-for="(item, index) in avatarStack"
                :key="index"
                class="list-item"
            >
                <CmsImage
                    :data="item.image"
                    fit="cover"
                />
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { useMenus } from '@/plugins/menu'

import CmsImage from '@/components/cms/CmsImage.vue'

const { avatarStack } = useMenus()
</script>

<style lang="scss" scoped>
.avatar-stack {
    width: 100%;

    .list {
        width: 230px;
        height: 70px;
        position: relative;
        margin: 0 auto;

        .list-item {
            width: 50px;
            height: 50px;
            display: block;
            position: absolute;
            top: 10px;
            left: 80px;
            border: 2px solid $stone-2;
            box-shadow: 0 0 10px rgb($black, 0.1);
            border-radius: 50%;
            overflow: hidden;

            &:nth-child(1) {
                width: 70px;
                height: 70px;
                top: 0;
                z-index: 3;
            }

            &:nth-child(2) {
                left: 0;
            }

            &:nth-child(3) {
                left: 40px;
                z-index: 2;
            }

            &:nth-child(4) {
                left: 140px;
                z-index: 2;
            }

            &:nth-child(5) {
                left: 180px;
            }
        }
    }
}
</style>
